'use client';

import { useTheme } from 'next-themes';
import type { ComponentProps } from 'react';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      duration={5000}
      toastOptions={{
        style: {
          background: 'hsl(var(--secondary) / 0.6)',
          color: 'hsl(var(--secondary-foreground))',
          border: '1px solid hsl(var(--border) / 0.5)',
        },
        classNames: { toast: 'backdrop-blur-sm shadow-lg' },
      }}
      {...props}
    />
  );
};

export { Toaster };
